import logoOriginal from "@/assets/lorier-logo.svg";
import loginIllustrationBackground from "@/assets/login-illustration-background.png";
import loginIllustration from "@/assets/login-illustration-2.png";
import loginIllustrationIcon from "@/assets/login-illustration-icon.svg";
import PasswordLoginForm from "@/features/auth/components/forms/password-login-form";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const { t } = useTranslation();
  return (
    <main className="h-screen w-full flex">
      <section className="flex-1 flex flex-col items-center lg:justify-center pt-30 lg:pt-0 bg-white px-8">
        <img src={logoOriginal} alt="Lorier Logo" className="w-30 md:w-40" />
        <h3 className="text-2xl font-bold my-8">
          {t("modules.auth.login_form.title")}
        </h3>
        <PasswordLoginForm />
      </section>
      <section className="flex-1 hidden lg:flex h-full bg-primary items-center justify-center relative pl-5">
        <img
          src={loginIllustrationBackground}
          className="absolute size-full w-full h-full inset-0"
        />
        <figure className="relative flex items-center w-96 justify-center">
          <img src={loginIllustration} className="w-full" />
          <img
            src={loginIllustrationIcon}
            className="absolute top-1/2 left-1/2 -translate-x-[216px] -translate-y-1/2"
          />
        </figure>
      </section>
    </main>
  );
};

export default LoginPage;
